'use client'

import React from 'react'

import { SpaceProps } from '../../themes'
import loadingAnimation from './loading.json'
import { Container } from './styles'

// Lazy load Lottie
const Lottie = React.lazy(() => import('lottie-react'))

export interface LoadingProps extends SpaceProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Loading size
   */
  size?: 'sm' | 'md' | 'lg'

  /**
   * Center element (using absolute positioning)
   */
  centered?: boolean
}

const sizeMap = {
  sm: 100,
  md: 160,
  lg: 320,
} as const

export const Loading = ({
  className,
  size = 'md',
  centered = false,
  ...spaceProps
}: LoadingProps) => {
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <Container className={className} centered={centered} {...spaceProps}>
      {isClient && (
        <Lottie
          style={{
            height: sizeMap[size],
            width: sizeMap[size],
          }}
          animationData={loadingAnimation}
          loop
          autoplay
        />
      )}
    </Container>
  )
}
